import { Radio as BaseRadio } from '@base-ui/react/radio';
import { RadioGroup as BaseRadioGroup } from '@base-ui/react/radio-group';
import * as stylex from '@stylexjs/stylex';
import '../../../../styles/tokens.stylex';
import { borderRadius, easing, shadow, size, spacing, timing } from '../../../../styles/tokens.stylex';
import '../../markers.stylex';
import { checkableMarker, inputIconMarker, labelMarker } from '../../markers.stylex';
import '../../form.tokens.stylex';
import { formTokens } from '../../form.tokens.stylex';
import { MaxColumnGrid } from '@/components/MaxColumnGrid';
import { use } from 'react';
import { FieldControlContext } from './Field';
type BaseUICompositeType<T> = {
  styles?: stylex.StyleXStyles;
} & T;
function Root(props: BaseUICompositeType<BaseRadio.Root.Props>) {
  return <BaseRadio.Root {...props} {...stylex.props(checkableMarker, sx.root, props.styles)} />;
}
function Indicator(props: BaseUICompositeType<BaseRadio.Indicator.Props>) {
  return <BaseRadio.Indicator keepMounted {...props} {...stylex.props(sx.indicator, props.styles)} />;
}
function RadioGroup({
  columns = 3,
  ...props
}: BaseUICompositeType<BaseRadioGroup.Props> & {
  columns?: number;
}) {
  const fieldControl = use(FieldControlContext);
  return <BaseRadioGroup {...fieldControl} {...props} render={<MaxColumnGrid maxColumns={columns} minColumnWidth="xs" gap="sm" styles={[sx.radioGroup, props.styles]} />} />;
}
export const Radio = {
  Root,
  Indicator,
  RadioGroup
};
const sx = {
  root: {
    kVAM5u: "xwsnfrh x16m9s1f x1nbio5p",
    kaIpWk: "x4dzasd",
    ksu8eU: "x1y0btm7",
    kMzoRj: "x1q469ie",
    kGNEyG: "x6s0dn4",
    kWkggS: "x1o47r4 xj4d6mi",
    kGVxlE: "xw90h5g",
    k1xSpc: "x78zum5",
    kmuXW: "x2lah0s",
    k87sOh: "xy11dvg",
    kLqNvP: "x1vt5lg4",
    kjj79g: "xl56j7k",
    kVAEAm: "x1u5hf2f",
    kZKoxP: "xxk0z11",
    kzqmXN: "xvy4d1p",
    $$css: true
  },
  indicator: {
    kaIpWk: "x4dzasd",
    kmkexE: "x9lqykl",
    kWkggS: "xsox1gu",
    k1xSpc: "x1lliihq",
    kSiTet: "xg01cxk xdavzed xyn2shw",
    kZKoxP: "x17lid0",
    kzqmXN: "xjjx1xd",
    $$css: true
  },
  radioGroup: {
    $$css: true
  }
};